/**
 * Payment Icons Fallback Script
 * Ensures payment icons load properly with fallback handling
 */

(function() {
  'use strict';
  
  function initPaymentIcons() {
    const paymentIcons = document.querySelectorAll('.payment-icon');
    const paymentContainer = document.querySelector('[data-footer-payment-icons]');
    
    // Ensure container is visible
    if (paymentContainer) {
      paymentContainer.style.display = 'flex';
      paymentContainer.style.visibility = 'visible';
      paymentContainer.style.opacity = '1';
    }
    
    paymentIcons.forEach(function(icon) {
      // Ensure icon is visible by default
      icon.style.display = 'inline-block';
      icon.style.visibility = 'visible';
      icon.style.opacity = '1';
      
      // Add error handling
      icon.addEventListener('error', function() {
        if (window.logger) {
          window.logger.warn('Payment icon failed to load:', this.alt);
        }
        this.style.display = 'none';
      });
      
      // Add load success handling
      icon.addEventListener('load', function() {
        this.style.opacity = '1';
        this.style.visibility = 'visible';
        this.classList.add('payment-icon-loaded');
      });
      
      // If image is already loaded, make it visible
      if (icon.complete && icon.naturalHeight !== 0) {
        icon.style.opacity = '1';
        icon.style.visibility = 'visible';
        icon.classList.add('payment-icon-loaded');
      }
    });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPaymentIcons);
  } else {
    initPaymentIcons();
  }
  
  // Also initialize when lazy loading completes
  document.addEventListener('lazyloaded', function(e) {
    if (e.target.classList.contains('payment-icon')) {
      initPaymentIcons();
    }
  });
})();